var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteStage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 3.66667H11.4819M10.863 3.66667L10.3263 11.7613C10.3041 12.0977 10.1643 12.4125 9.93516 12.6424C9.70602 12.8722 9.40453 13 9.09141 13H3.96866C3.65554 13 3.35404 12.8722 3.12491 12.6424C2.89577 12.4125 2.75601 12.0977 2.73378 11.7613L2.19711 3.66667H10.863ZM5.29206 6.33333V10.3333V6.33333ZM7.76801 6.33333V10.3333V6.33333ZM8.387 3.66667V1.66667C8.387 1.48986 8.32179 1.32029 8.2057 1.19526C8.08962 1.07024 7.93218 1 7.76801 1H5.29206C5.12789 1 4.97045 1.07024 4.85437 1.19526C4.73828 1.32029 4.67307 1.48986 4.67307 1.66667V3.66667H8.387Z",
    stroke: "#000000",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteStage);
export default __webpack_public_path__ + "static/media/icon--delete-stage.16cde9ac668de9284885e8c52c9e7f45.svg";
export { ForwardRef as ReactComponent };